// extracted by mini-css-extract-plugin
module.exports = {"errorColor":"autoEditTable_errorColor__3vr9-"};